// client/src/utils/secureApi.js

// Get token from localStorage
const getToken = () => {
  return localStorage.getItem('buoy-auth-token');
};

// Create headers with authentication
const createHeaders = (additionalHeaders = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...additionalHeaders
  };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

// Secure fetch wrapper
export const secureApi = {
  async get(url) {
    const response = await fetch(url, {
      method: 'GET',
      headers: createHeaders()
    });
    
    if (response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('buoy-auth-token');
      window.location.reload(); // Force re-authentication
    }
    
    return response;
  },

  async post(url, data) {
    const response = await fetch(url, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify(data)
    });
    
    if (response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('buoy-auth-token');
      window.location.reload(); // Force re-authentication
    }
    
    return response;
  },

  async delete(url) {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: createHeaders()
    });
    
    if (response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('buoy-auth-token');
      window.location.reload(); // Force re-authentication
    }
    
    return response;
  }
};

export default secureApi;